import { isEmpty } from 'lodash';
import { AfterCellChanged, Cells, ConfigurationSpreadsheets, InitialChanges } from 'common/types/scalarSpreadsheet';
import { EQUITY_ALLOCATION_KEY } from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import { EQUITY_ALLOCATION_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY } from 'pages/ValuationsAllocation/common/constants/equityAllocation/sheetAliases';
import { VALUATION_SUMMARY_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY } from 'pages/ValuationsAllocation/common/constants/valuationSummary/sheetAliases';
import { adjustProbabilityValues } from 'pages/ValuationsAllocation/util';

const customAfterCellsChanged: AfterCellChanged = (
  initialChanges: InitialChanges[],
  cells: Cells,
  rowConfig: ConfigurationSpreadsheets['rowConfig'],
  tableData: ConfigurationSpreadsheets['tableData'],
  spreadsheets: Cells
) => {
  const changes = [...initialChanges];
  initialChanges.forEach(change => {
    const { cell, value } = change;
    const { alias } = cell;
    
    if (alias === VALUATION_SUMMARY_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY) {
      // Use adjustProbabilityValues to handle probability adjustments
      const probabilityChanges = adjustProbabilityValues({
        cells,
        changedCell: cell,
        newValue: value,
        probabilityCellAlias: VALUATION_SUMMARY_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY,
        summaryCellAlias: EQUITY_ALLOCATION_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY,
        summarySpreadsheet: spreadsheets[EQUITY_ALLOCATION_KEY]
      });
      
      // Add all changes to the main changes array
      changes.push(...probabilityChanges);
    }

    // Allocation scenario columns (except the weighting cell)
    if (!isEmpty(cell.data) && cell.alias !== VALUATION_SUMMARY_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY) {
      const probabilityChanges = adjustProbabilityValues({
        cells: Object.values(cells)
          .filter(c => c.columnLegend === cell.columnLegend
            && c.alias !== VALUATION_SUMMARY_SPREADSHEET_SCENARIO_WEIGHTING_PROBABILITY)
          .reduce((acc, currentCell) => ({
            ...acc, 
            [String(currentCell.key)]: currentCell
          }), {}),
        changedCell: cell,
        newValue: value,
        probabilityCellAlias: '',
      });

      changes.push(...probabilityChanges);
    }
  });
  return changes;
};

export default customAfterCellsChanged;
